(() => {
  const ACTIVE_CLASS = 'countdown-purchase-gate-active';
  const TIMER_SELECTOR = '.countdown-timer-block';
  const TIMER_CONTENT_SELECTOR = '.essential_countdown_timer';

  const script = document.currentScript;
  const productGateIsEnabled = script?.dataset.productEnabled === 'true';
  const localTestIsEnabled = window.location.hostname === '127.0.0.1'
    && new URLSearchParams(window.location.search).get('countdown-gate-test') === '1';

  let lastActiveState = null;

  const revealPurchaseControls = () => {
    document.documentElement.classList.remove(ACTIVE_CLASS);
    document.documentElement.dataset.countdownPurchaseGate = 'open';
    lastActiveState = false;
  };

  const timerIsActive = (timer) => {
    if (!timer.querySelector(TIMER_CONTENT_SELECTOR)) {
      return false;
    }

    const style = window.getComputedStyle(timer);
    const bounds = timer.getBoundingClientRect();

    return style.display !== 'none'
      && style.visibility !== 'hidden'
      && bounds.width > 1
      && bounds.height > 1;
  };

  const syncPurchaseControls = () => {
    try {
      const timerIsVisible = Array.from(document.querySelectorAll(TIMER_SELECTOR)).some(timerIsActive);

      if (timerIsVisible === lastActiveState) {
        return;
      }

      document.documentElement.classList.toggle(ACTIVE_CLASS, timerIsVisible);
      document.documentElement.dataset.countdownPurchaseGate = timerIsVisible ? 'locked' : 'open';
      lastActiveState = timerIsVisible;
    } catch (error) {
      revealPurchaseControls();
    }
  };

  const observer = new MutationObserver(syncPurchaseControls);

  if (!productGateIsEnabled && !localTestIsEnabled) {
    revealPurchaseControls();
    return;
  }

  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class', 'style'],
    childList: true,
    subtree: true
  });

  window.addEventListener('pageshow', syncPurchaseControls);
  window.setInterval(syncPurchaseControls, 1000);
  syncPurchaseControls();
})();
